module.exports = __webpack_public_path__ + "img/secediticon.ad1bcfa8.svg";